import React, { useRef, useEffect } from 'react';
import ChatMessage from '../atoms/ChatMessage';
import TypingIndicator from '../atoms/TypingIndicator';

const ChatMessageList = ({ messages, isLoading, isTyping }) => {
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isLoading, isTyping]);

  return (
    <div className="flex-1 overflow-y-auto p-6 space-y-6 bg-gradient-to-b from-gray-50/50 to-white chat-messages">
      {messages.map((message, index) => (
        <div
          key={message.id}
          style={{ animationDelay: `${index * 0.1}s` }}
        >
          <ChatMessage 
            message={message} 
            isUser={message.type === "user"} 
          />
        </div>
      ))}
      
      {(isLoading || isTyping) && <TypingIndicator />}
      
      <div ref={messagesEndRef} />
    </div>
  );
};

export default ChatMessageList;